<app-link
    class="resource-browse-card gtm-results-browse-card selenium-resource-browse-card"
    [attr.data-gtmlabel]="learningObject.title"
    [attr.data-gtmresultindex]="gtmDataCardNumber"
    [tabIndex]="isInPreviewMode ? -1 : 0"
    [ngClass]="{
        large: this.isLargeCard(),
        medium: this.isMediumCard(),
        'preview-grayscale': isInPreviewMode,
    }"
    [appRouterLink]="learningObject.routerLink"
>
    <app-language-badge
        *ngIf="learningObject.languages.length > 1 || learningObject.languages.includes('Spanish')"
        [languages]="learningObject.languages"
    ></app-language-badge>
    <div class="header">
        <app-resource-card-poster
            class="thumbnail"
            [posterImage]="
                learningObject.getPosterImage(getPosterImageWidth(), getPosterImageHeight())
            "
            [duration]="learningObject.duration"
            [gtmPrefix]="gtmPrefix"
            [title]="learningObject.linkTitle"
            [mediaType]="getMediaType()"
            [absoluteUrl]="learningObject.canonicalUrl"
            [gtmDataCardNumber]="gtmDataCardNumber"
        >
        </app-resource-card-poster>
    </div>
    <div class="content">
        <span
            [attr.aria-label]="learningObject.title ? 'Open ' + learningObject.title : null"
            [class]="getResourceBodyClass()"
            [attr.data-gtmlabel]="learningObject.canonicalUrl"
        >
            <app-card-title [height]="titleHeight()">
                <span [innerHtml]="learningObject.title"></span>
            </app-card-title>
        </span>
        <app-card-description *ngIf="!isMediumCard()"
            ><span [innerHtml]="learningObject.description | safeTruncate: truncateSize()"></span>
        </app-card-description>
        <app-browse-card-meta
            [supportMaterialsCount]="learningObject.supportMaterials.length"
            [supportMaterialsLink]="learningObject.routerLink"
            [contentProject]="learningObject.project"
            [gradesDisplay]="learningObject.gradesDisplay"
            [brand]="learningObject.brand"
            [gtmDataCardNumber]="gtmDataCardNumber"
        ></app-browse-card-meta>
    </div>
</app-link>
